/**
 * King Living Override - TeaserTileBlock Fragment
 *
 * Override to include TeaserTileFragment (with image) instead of BaseTeaserTileFragment
 */

import gql from 'graphql-tag';

import {BaseTeaserTileBlockFragment} from '@amblique/contentful/app/contentful/fragments/teaser-tile-block/base-teaser-tile-block.fragment';
import {TeaserTileFragment} from '@amblique/contentful/app/contentful/fragments/teaser-tile/teaser-tile.fragment';

export const TeaserTileBlockFragment = gql`
  ${BaseTeaserTileBlockFragment}
  ${TeaserTileFragment}

  fragment TeaserTileBlockFragment on TeaserTileBlock {
    ...BaseTeaserTileBlockFragment

    teaserTilesCollection {
      items {
        __typename
        ... on TeaserTile {
          ...TeaserTileFragment
        }
      }
    }
  }
`;
